'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var acceptedMessageBuilder = function acceptedMessageBuilder(input) {
    var amount = input.amount,
        bidderId = input.bidderId,
        created = input.created,
        currency = input.currency,
        myBid = input.myBid,
        outbid = input.outbid,
        paddleNumber = input.paddleNumber,
        previousBidAmount = input.previousBidAmount,
        source = input.source;


    var data = {
        amount: amount,
        bidderId: bidderId,
        currency: currency,
        paddleNumber: paddleNumber,
        previousBidAmount: previousBidAmount,
        source: source
    };

    var nonLaBidder = bidderId === 0;

    switch (source) {
        case 'Absentee':
            if (myBid) {
                return [
                // Fake a bid accepted because we dont get info on the bid that was rejected because of the absentee bid
                {
                    created: created,
                    data: (0, _extends3.default)({}, data, {
                        bidderId: 0
                    }),
                    messageId: 'bidding_console.console.messages.competing_bid_amount',
                    type: 'accepted'
                },
                // My absentee bid was accepted
                {
                    created: created + 1,
                    data: data,
                    messageId: 'bidding_console.console.messages.my_bid_amount_absentee',
                    type: 'mybid'
                }];
            } else if (outbid) {
                if (previousBidAmount !== 0) {
                    return [
                    // Fake that the users bid was accepted so that we can show the correct messaging about them being outbid by an absentee bid
                    {
                        created: created,
                        data: data,
                        messageId: 'bidding_console.console.messages.my_bid_amount',
                        type: 'mybid'
                    },
                    // Message saying they were outbid by an absentee bid
                    {
                        created: created + 1,
                        data: data,
                        messageId: 'bidding_console.console.messages.you_been_outbid_by_liveauctioneers_absentee',
                        type: 'outbid-absentee'
                    },
                    // Message saying that an absentee bid was accepted
                    {
                        created: created + 2,
                        data: data,
                        messageId: 'bidding_console.console.messages.liveauctioneers_bid_amount_absentee',
                        type: 'accepted'
                    }];
                }
                return [
                // Message saying that an absentee bid was accepted
                {
                    created: created + 2,
                    data: data,
                    messageId: 'bidding_console.console.messages.liveauctioneers_bid_amount_absentee',
                    type: 'accepted'
                }];
            }
            return [
            // Fake a bid accepted because we dont get info on the bid that was rejected because of the absentee bid
            {
                created: created,
                data: (0, _extends3.default)({}, data, {
                    bidderId: 0
                }),
                messageId: 'bidding_console.console.messages.competing_bid_amount',
                type: 'accepted'
            },
            // Message indicating that someone was outbid by an absentee bid
            {
                created: created + 1,
                data: data,
                messageId: 'bidding_console.console.messages.competing_bidder_outbid_by_liveauctioneers_absentee',
                type: 'absentee-outbid'
            },
            // Message saying that an absentee bid was accepted
            {
                created: created + 2,
                data: data,
                messageId: 'bidding_console.console.messages.liveauctioneers_bid_amount_absentee',
                type: 'accepted'
            }];
        case 'Reserve':
            return [
            // Message indicating that the reserve was not met
            {
                created: created + 1,
                data: data,
                messageId: 'bidding_console.console.messages.reserve_not_met',
                type: 'reserve'
            }];

        default:
            if (myBid) {
                // Message indicating that the users bid was accepted
                return [{
                    created: created,
                    data: data,
                    messageId: 'bidding_console.console.messages.my_bid_amount',
                    type: 'mybid'
                }];
            }

            // message indicating that a bid was accepted
            return [{
                created: created,
                data: data,
                messageId: nonLaBidder ? 'bidding_console.console.messages.competing_bid_amount' : 'bidding_console.console.messages.liveauctioneers_bid_amount',
                type: 'accepted'
            }];
    }
};

exports.default = acceptedMessageBuilder;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/acceptedMessageBuilder.js
// module id = /dTY
// module chunks = 60